<template>
  <b-row>
    <b-col md="4" v-for="item in list" :key="item.id" class="mb-4">
      <ProductCard
        :img="item.img"
        :name="item.name"
        @click="$emit('select', item.id)"
      />
    </b-col>
  </b-row>
</template>

<script>
import ProductCard from '@/components/ProductCard.vue'

export default {
  name: 'ProductGrid',
  components: { ProductCard },
  props: {
    list: { type: Array, default: () => [] }
  }
}
</script>
